var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNightImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 383,
    viewBox: "0 0 500 383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.516,
    y1: 0.93,
    x2: 0.512,
    y2: 0.269,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d43"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "night_image",
    "data-name": "night image",
    transform: "translate(-678 -214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M74,405V64a42,42,0,0,1,42-42H532a42,42,0,0,1,42,42V405Z",
    transform: "translate(604 192)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud2",
    transform: "translate(259 38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 161,
    height: 66,
    rx: 33,
    transform: "translate(461 301)",
    fill: "#56567c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 38,
    cy: 37.5,
    rx: 38,
    ry: 37.5,
    transform: "translate(466 253)",
    fill: "#56567c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 38,
    cy: 37.5,
    rx: 38,
    ry: 37.5,
    transform: "translate(518 278)",
    fill: "#56567c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud2-2",
    "data-name": "cloud2",
    transform: "translate(584 36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 123,
    height: 50,
    rx: 25,
    transform: "translate(461 290)",
    fill: "#56567c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5",
    cx: 29,
    cy: 28.5,
    rx: 29,
    ry: 28.5,
    transform: "translate(465 253)",
    fill: "#56567c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6",
    cx: 29,
    cy: 28.5,
    rx: 29,
    ry: 28.5,
    transform: "translate(505 272)",
    fill: "#56567c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "moon",
    transform: "translate(-222 58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M75,194A75,75,0,1,1,75,44a75.9,75.9,0,0,1,11.308.847A74.455,74.455,0,0,0,80,75c0,36.785,27.382,68.664,63.692,74.154A75.022,75.022,0,0,1,75,194Z",
    transform: "translate(978 199)",
    fill: "#fff598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M75,162A74.938,74.938,0,0,1,0,87a75.035,75.035,0,0,1,30.994-60.74A75,75,0,0,0,132.005,135.74,75.259,75.259,0,0,1,106.9,154.9a74.6,74.6,0,0,1-15.3,5.26A75.434,75.434,0,0,1,75,162Z",
    transform: "translate(978 231)",
    fill: "#e3d873"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M52,164V39.241A41.536,41.536,0,0,1,87.555,69.606a41.54,41.54,0,0,1,55.476,22.451A36,36,0,0,1,141,164Z",
    transform: "translate(626 295)",
    fill: "#56567c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightImage);
export default __webpack_public_path__ + "static/media/night_image.5af6e188357c48ab3946ba071c5e3646.svg";
export { ForwardRef as ReactComponent };